module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/ata-icon.e9507051.png";